import { render } from "./AdminRaterangeEdit.vue?vue&type=template&id=529b22da&scoped=true&ts=true&lang=true"
import script from "./AdminRaterangeEdit.vue?vue&type=script&lang=ts"
export * from "./AdminRaterangeEdit.vue?vue&type=script&lang=ts"

import "./AdminRaterangeEdit.vue?vue&type=style&index=0&id=529b22da&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529b22da"]])

export default __exports__